<template>
  <div v-scroll="onScroll" class="h-100" v-resize="OnResize">
    <!-- <UserNavigationDrawer :showMenu="showMenu" />
    <Header
      v-bind:offsetTop="offsetTop"
      @action="onAction"
      v-if="isPersonalizepage"
    /> -->
    <v-main class="h-100">
      <slot></slot>
      <vue-snotify />
    </v-main>
  </div>
</template>

<script>
// import UserNavigationDrawer from "@/components/common/UserNavigationDrawer.vue";
// import Header from "@/components/layout/header/Header.vue";
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "layout/getField",
  mutationType: "layout/updateField",
});

export default {
  name: "DefaultLayout",

  components: {
    // Header,
    // UserNavigationDrawer,
  },

  data: () => ({
    offsetTop: 0,
    showMenu: false,
    categoryList: [],
    activeMainMenu: "",
    activeSubMenu: "",
    activeSubMenuItem: "",
    search: null,
    searchResultList: [],
    lookupCatelog: null,
    searchInProgress: false,
    pageNo: 1,
    pageSize: 9,
    sortSelect: { label: "Position", value: "position" },
  }),
  computed: {
    inProgress: function () {
      return this.$store.state.headerCategoryList.inProgress;
    },
    guestQuoteId: function () {
      return this.$store.state.cartProduct.guestQuoteId;
    },
    isDesktop: function () {
      return this.$vuetify.display.xs ? true : false;
    },
    isPersonalizepage: function () {
      let currentPage = this.$route.name;
      if (
        currentPage === "ProductPersonalizeDesignerMode" ||
        currentPage === "ProductPersonalize" ||
        currentPage === "ProductSummary" ||
        currentPage === "ProductSummaryDesignerMode"
      )
        return false;
      else return true;
    },
    designerModeFlag: function () {
      if (
        this.$route.params.designerMode &&
        this.$route.params.designerMode == "true"
      )
        return true;
      return false;
    },
    userAuth: function () {
      return this.$store.state.auth.userAuth;
    },
    userName: function () {
      return this.$store.state.accountOne.one.firstname;
    },
    ...mapFields(["user", "user.userVisits"]),
  },
  methods: {
    onScroll() {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    },
    onAction(action) {
      this.showMenu = action.showMenu;
      this.categoryList = action.categoryList;
    },
    OnResize() {
      setTimeout(() => {
        if (this.$vuetify.display.mdAndUp) {
          this.showMenu = false;
        }
      }, 200);
    },
  },
};
</script>
<style lang="scss">
.header-input-custom {
  .v-input__control {
    background-color: transparent !important;
  }
  .v-input__slot {
    &:before {
      border-color: #ffffff !important;
      border-style: solid;
      border-width: 1px;
    }
    &:after {
      border-color: #ffffff !important;
      border-style: solid;
      border-width: 1px;
    }
  }
  .v-text-field__slot {
    input {
      color: #ffffff !important;
      border-bottom-color: #ffffff !important;
    }
    input::placeholder {
      color: #ffffff !important;
    }
    input:-ms-input-placeholder {
      color: #ffffff !important;
    }

    input ::-ms-input-placeholder {
      color: #ffffff !important;
    }
  }
  .v-icon {
    color: #ffffff !important;
  }
  .mobile-header-list.theme--light.v-list {
    background: #2805da;
  }
  .v-list-item__icon {
    color: #ffffff !important;
  }
  .z-index-1000 {
    z-index: 1000 !important;
  }
}
.mobile-header-autocomplete .v-input__append-inner .v-input__icon {
  display: none !important;
}
.mobile-header-autocomplete .theme--light.v-icon {
  color: #ffffff !important;
}
.mobile-header-autocomplete.theme--light.v-input input {
  color: #ffffff !important;
}
.mobile-header-autocomplete.theme--light.v-text-field--filled
  > .v-input__control
  > .v-input__slot {
  background-color: transparent !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
<style src="./Layout.scss" lang="scss" />
